module.exports = __webpack_public_path__ + "static/media/checkcyan.fe9e1098.svg";